export default {
	layout: {
		padding: {
			left: 50,
			right: 50,
			top: 50,
			bottom: 50,
		},
	},
	plugins: {
		datalabels: { clamp: true, anchor: "end", align: "end", offset: 5 },
	},
	legend: {
		display: true,
		position: "bottom",
	},
	scales: {
		xAxes: [
			{
				ticks: {
					beginAtZero: true,
				},
			},
		],
	},
}